export default "__VITE_ASSET__95c33b13__"